import { RpcException } from "@/lib/client/types.ts"

import type { FailureInfo as ClientFailureInfo } from "@/lib/client/types.ts"

export type ExtendedFailureInfo = ClientFailureInfo & {
  securityError?: string
  validationError?: { errors: Array<{ message: string; parameter?: string }>; printAllErrors?: boolean }
  notFoundError?: string
}

export function isRpcException(e: unknown): e is RpcException {
  return (
    e instanceof RpcException ||
    (typeof e === "object" && e !== null && "failure" in (e as Record<string, unknown>))
  )
}

export function extractRpcErrorMessage(error: unknown): string {
  // Prefer server-provided failure info if present; otherwise fall back to Error.message or String(error)
  if (isRpcException(error)) {
    const f = error.failure as ExtendedFailureInfo
    const validationMsg = f.validationError?.errors?.[0]?.message
    return (
      f.authenticationError ||
      f.securityError ||
      f.requestError ||
      f.transportError ||
      f.notFoundError ||
      validationMsg ||
      error.message
    )
  }
  return error instanceof Error ? error.message : String(error)
}
